import React from 'react';
import Spinner from '../Spinner';

/* A simple unopinionated component to handle displaying async data and errors. */
/*
  Accepts the following props: 
    loading: boolean
    children: a function returning a React component or fragment
    (optional) error: boolean
    (optional) errorComponent: a React component to display when a error occurs
    (optional) loadingComponent: a React component to display when loading
  Use in the form of:
    <LoadOrError loading={loading} error={error}>
      {() => 
        // some component 
      }
    </>
  Note: that the children _must_ be passed inside of a function, which allows the
  execution of that component to occur only after after a successful request.
*/

const LoadOrError = ({
  children,
  loading,
  error = false,
  errorComponent = false,
  loadingComponent = false,
}) => {
  if (loading) {
    return loadingComponent || <Spinner />;
  }

  if (error) {
    return errorComponent || 'An error has ocurred while fetching data.';
  }

  return children();
};

export default LoadOrError;
